import React from 'react';
import PropTypes from 'prop-types';
import { Button, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { FlexRightSpaced } from '../../components/Styled/Containers';
import { loadInvitedCarriers } from '../../store/actions/carriers';
import config from '../../config';
import { getMeId, getSelectedCompany } from '../../store/selectors';
import RefreshButton from '../../components/Table/ReloadButton';

const InvitationText = styled.p`
  /* p14 */
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  /* Gray 2 */
  color: #4F4F4F;
  opacity: 0.8;
`;

// const invitationLink = config.invitation.link;

const CarrierHeaderComponent = ({
  size, withRefresh,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedCompany = useSelector(getSelectedCompany);
  const userId = useSelector(getMeId);

  window.copyAndNotify = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => message.success(t('COMMON.COPIED_TO_CLIPBOARD')));
  };

  const copyInvitationLinkPernament = () => {
    window.copyAndNotify(`${config.invitation.link}/perm-invite?companyId=${selectedCompany}&userId=${userId}`);
  };

  const copyInvitationLinkOrders = () => {
    window.copyAndNotify(`${config.invitation.link}/invite?companyId=${selectedCompany}&userId=${userId}`);
  };

  const onRefresh = () => {
    dispatch(loadInvitedCarriers(false));
  };

  return (
    <>
      <FlexRightSpaced>
        <InvitationText style={{ marginTop: '15px' }}>{t('PROPERTIES.INVITATION_HELP_TEXT')}</InvitationText>
        <Button
          type="primary"
          size={size}
          icon={<CopyOutlined />}
          onClick={copyInvitationLinkOrders}
        >
          {t('PROPERTIES.INVITATION_LINK_ORDERS')}
        </Button>
        <Button
          type="primary"
          size={size}
          icon={<CopyOutlined />}
          onClick={copyInvitationLinkPernament}
        >
          {t('PROPERTIES.INVITATION_LINK_PERNAMENT')}
        </Button>
        {withRefresh?.enabled
          ? (
            <RefreshButton
              size={size}
              onClick={onRefresh}
              compact={withRefresh.compact}
            />
          ) : null}
      </FlexRightSpaced>
    </>
  );
};

CarrierHeaderComponent.propTypes = {
  size: PropTypes.string,
  withRefresh: PropTypes.shape({
    onRefresh: PropTypes.func.isRequired,
    enabled: PropTypes.bool,
    loading: PropTypes.bool,
    compact: PropTypes.bool,
  }),
};

CarrierHeaderComponent.defaultProps = {
  size: 'small',
  withRefresh: null,
};

export default CarrierHeaderComponent;
